<div class="body-text left time-tracking">
  @if (!paused) {
    <div><span class="dot"></span>Active</div>
  }
  @if (paused) {
    <div><span class="dot paused"></span>Paused</div>
  }
  @if (activeDays !== null) {
    <div
      matTooltip="Active Days"
      class="card-active-days"
    [ngClass]="{
      'inactive-timer': paused
    }"
      >
      <mat-icon class="icon">calendar_month</mat-icon>
      {{ isOverdue ? maxActiveDays + '+' : activeDays }}
    </div>
  }
  @if (pausedDays !== null) {
    <div
      matTooltip="Paused Days"
      class="card-paused-days"
    [ngClass]="{
      'inactive-timer': !paused
    }"
      >
      <mat-icon class="icon">pause</mat-icon>
      {{ pausedDays }}
    </div>
  }
  @if (dueDate && activeDays !== null) {
    <div>
      @if (!isOverdue) {
        <span>Due: {{ dueDate | momentFormat }}</span>
      }
      @if (isOverdue) {
        <span class="red-text">Overdue</span>
      }
    </div>
  }
</div>
